import axios from 'axios';
import { getChannelToken_v1 } from 'js/library/utils/API/getChannelToken_v1';
import cfac22 from '../cfac22';

export function getCardByIdNode(cardId) {
  return new Promise((resolve, reject) => {
    getChannelToken_v1()
      .then((token) => {
        axios
          .get(cfac22('API_HOST_V2') + `/cards/getCardById/?cardId=${cardId}`, {
            headers: { authorization: 'Bearer ' + token, 'Full-Url': window.location.href },
          })
          .then((result) => {
            resolve(result.data.result);
          })
          .catch((error) => {
            return reject(error.data.error);
          });
      })
      .catch((error) => {
        // console.log("ERROR_TOKEN ===>", error);
        reject(error.response.data);
      });
  });
}
